import { Button, Card, CardBody, Col, Container, ListGroup, li, Row } from "react-bootstrap";
import ChariarPic from "../image/VMChariar.jpg";
import chariarCV from "../docs/chariarCvLatest.pdf";
import chariarBio from "../docs/chariarBio.pdf";
import Background from "../image/background1.png";
import Background2 from "../image/background2.jpg";
import { useState, useEffect } from "react";

//css import for only home
import "../CSS/home.css";

export default function Home() {
    const [displayPub, setDisplayPub] = useState(null);

    const getData = () => {
        fetch(process.env.PUBLIC_URL + '/data/publications.json'
            , {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            }
        )
            .then(function (response) {
                // console.log(response)
                return response.json();
            })
            .then(function (myJson) {
                // console.log(myJson);
                // setPublication(myJson);
                if (myJson !== null) {
                    // console.log("pub function called");
                    var pub = new Array();
                    pub[0] = myJson.filter(p => p.type === 'book')[0];
                    pub[1] = myJson.filter(p => p.type === 'patent')[0];
                    pub[2] = myJson.filter(p => p.type === 'journal')[0];
                    pub[3] = myJson.filter(p => p.type === 'conference')[0];
                    setDisplayPub(pub);
                    // console.log(pub);
                }
            });
    }

    useEffect(() => {
        getData();
    }, [])

    const Pub = displayPub !== null ? () =>
        // console.log(displayPub);
        displayPub.map(p => <Col sm="12" md="6" lg="3" key={p.title + p.year}>
            <Card style={{ marginBottom: "30px" }} className="publications-list">
                { /* <Card.Img variant="top" src={ p.image?process.env.PUBLIC_URL+"/data/images/publication/"+p.image:process.env.PUBLIC_URL+"/data/images/publication_placeholder.jpg"} /> */}
                <CardBody>{p.title}, {p.authors}, {p.publication}, {p.year}{p.status != null ? ' (' + p.status + ')' : ' '}</CardBody>
            </Card>
        </Col>)
        : () => <div>No Records</div>;

    return (
        <>
            <Container fluid style={{ backgroundColor: "#FEFDF8" }}>
                <Container>
                    <Row className="section justify-content-center">
                        <Col md="4" sm="12"><img src={ChariarPic} width={"100%"} style={{ borderRadius: "50% 10px 50% 50%" }} /></Col>
                        <Col md="8" xl="6" sm="12" className={"hero-text"}>
                            <h2 style={{ marginTop: 0 }}>How Can We Partner with Rural Communities to Build an Abundant and Aesthetic World?
                            </h2>
                            <p>
                                Rural India has abundant natural resources and immense vernacular knowledge. The time-tested Traditional Knowledge of our Rural People – Farmers, Artisans, Forest Dwellers and Women is a great intangible wealth which ought to be used to progress towards a humane and ecological world.

                                In implementing development programs of sanitation, housing, well-being & livelihoods, there is immense value in a framework that respects inclusion, complementarity, natural abundance and aesthetics (सामाजिकता, परस्परता, समृद्धि, सौंदर्य दृष्टि). Such a framework promotes grassroots creativity, frugal innovation, sustainable design and interconnectedness.
                            </p>
                            <Button href="./research/overview">Explore Work <i className="bi bi-arrow-right"></i></Button>
                        </Col>
                    </Row>
                </Container>
            </Container>

            <Container fluid style={{ background: "url(" + Background + ") no-repeat fixed center" }}>
                <Container>
                    <Row className="justify-content-center section">
                        <Col md="10" className="image-over-section">
                            <h2 style={{ textAlign: "center", marginTop: "10px" }}>About My Continuing Adventures</h2>
                            <p>Compassion and Equity were fundamental principles that I grew up with. It was during my first Master's Degree that the journeys in the Western Ghats exposed me to the immense diversity, beauty and wonder that is the natural world. These journeys gave me the experience of natural abundance and amazing interconnectedness. This took me to study of the Mahatma's life & work where one was touched by the unconditional respect for all living and non-living beings. I began to appreciate how rich it was to practice frugal living.</p>
                            <p>During my doctoral research, I was drawn to the the concepts of just development and community knowledge. I began questioning the oppressive nature of reductionist thinking and fragmented ways of living. This resulted in deeper learning from amazing scholars who had spent decades in understanding tradition and interconnectedness. The simple yet profound works enabled me to always connect to the creative possibilities in existence and to the opportunities to always experience abundance. It has been and continues to be a joyous journey of learning and self-discovery!</p>

                        </Col>
                    </Row>
                </Container>
            </Container>

            <Container fluid style={{ backgroundColor: "#f8f8f8", borderTop: "1px solid #ddd" }}>
                <Container className="section">
                    <Row>
                        <Col sm="12" md="6" className={"col-spaced"}>
                            <h3 className="section-heading">Awards & Honors</h3>
                            <ul className="lined">
                                <li>Titan Design Impact Award for Zerodor Waterless Urinals, 2020</li>
                                <li>Grand Jury Member, FICCI India Sanitation Coalition Awards, 2017</li>
                                <li>Adjunct Faculty, GIOS, Arizona State University, 2017</li>
                                <li>Top 25 Innovative Startups by IIT Delhi Alumni Association, 2015</li>
                                <li>NextBig100 Company Award for Ekam Eco Solutions from The Hay Group , 2015</li>
                                <li>Senior Sustainability Fellow, GIOS, Arizona State University, 2015-2020</li>
                                <li>Member, National Task Force Rural Housing, Ministry of Rural Dev, GoI, 2014-19</li>
                                <li>Millennium Alliance Award 2014 instituted by FICCI, USAID, Govt of India</li>
                                <li>DST Lockheed Martin India Innovates Growth Programme Award 2014</li>
                                <li>PEER Science Awardee, National Academy of Sciences & USAID, 2013</li>
                                <li>Member, Global Phosphorous Research Network 2012-17 at Arizona State University</li>
                                <li>Fulbright Senior Scholar, Arizona State University, USA, 2012</li>
                                <li>Teaching Excellence Award, Indian Institute of Technology Delhi, 2011</li>
                                <li>Member, Committee on Rural Housing, Ministry of Rural Dev, GoI 2011-15</li>
                                <li>Member, Innovation Council, Min of Drinking Water & Sanitation, GoI 2010-15</li>
                                <li>Jury Member, Manthan Digital Empowerment Awards, 2008</li>
                                <li>KVIC Golden Jubilee Award for Rural Industrialization Innovations, 2007</li>
                                <li>Research Associate, Council of Scientific and Industrial Research, Govt of India, 1998</li>
                                <li>Young Scientist Award, Forum of Scientists for Peace & Development, 1997</li>
                            </ul>

                        </Col>
                        <Col md="6" sm="12" className={"col-spaced"}>
                            <h3 className="section-heading">Professional Experience</h3>
                            <ul>
                                <li>Co-Founder, JoyIsYou, 2019 - Present</li>
                                <li>Independent Director, Maganese Ore India Ltd, 2017-2020</li>
                                <li>Member, National Task Force Rural Housing, Ministry of Rural Development, 2014</li>
                                <li>Chairman, Ekam Eco Solutions, 2013 - Present</li>
                                <li>Member, Global Phosphorous Research Network, Arizona State University, 2012 - 2017</li>
                                <li>Member, Empowered Committee on Rural Housing, 2011</li>
                                <li>Member, Sectoral Innovation Council, Ministry of Drinking Water & Sanitation, 2010</li>
                            </ul>
                            <h3 className="section-heading">Academic Positions</h3>
                            <ul>
                                <li>Professor (HAG), Centre for Rural Development & Technology, IIT Delhi 2024 - Present</li>
                                <li>Professor, Centre for Rural Development and Technology (CRDT), IIT Delhi, 2017 - 2024</li>
                                <li>Guest Faculty, Department of Design, Anant National University, 2018 - 2019</li>
                                <li>Guest Faculty, Department of Design, School of Planning & Architecture, 2018 - 2019</li>
                                <li>Associate Professor, CRDT, IIT Delhi, 2010 - 2017</li>
                                <li>Fulbright Visiting Faculty, Arizona State University, USA 2012-2013</li>
                                <li>Assistant Professor, CRDT, IIT Delhi, 2005 - 2010</li>
                                <li>Assistant Professor, Department for Humanities and Social Sciences, IIT Kharagpur, 2003 - 2005</li>
                                <li>Lecturer, Physics Group, BITS Pilani, 2002 - 2003</li>
                                <li>Research Associate, NISTADS, New Delhi 1998-2000</li>
                            </ul>
                            <h3 className="section-heading">Education</h3>
                            <ul>
                                <li>PhD, 1998, Experimental Solid State Physics, Indian Institute of Technology, Delhi</li>
                                <li>M.Tech., 1993, Solid State Materials, Indian Institute of Technology, Delhi</li>
                                <li>M.Sc., 1991, Physics, Indian Institute of Technology, Bombay</li>
                                <li>B.Sc., 1989, Physics, University of Bombay</li>
                            </ul>
                        </Col>
                    </Row>
                    <Row className="justify-content-center">
                        <Col md="4" sm="12">
                            <div className="d-grid gap-2">
                                <Button href={chariarBio} target="_blank">Brief Bio <i className="bi bi-box-arrow-up-right"></i></Button>
                                <Button href={chariarCV} target="_blank">Detailed CV <i className="bi bi-box-arrow-up-right"></i></Button>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </Container>

            <Container fluid style={{ background: "url(" + Background2 + ") no-repeat fixed center" }}>
                <Container>
                    <Row className="justify-content-center section">
                        <Col md="10" className="image-over-section">
                            <h2 style={{ textAlign: "center", marginTop: "10px" }}>Featured Videos</h2>
                            <Row>
                                <Col md="6" sm="12">
                                    <div className="video-container">
                                        <iframe className="yt-video" width="100%" height="100%" src="https://www.youtube.com/embed/mSQ7calm5xM?si=-oYONmh7YXS7bTPb" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
                                    </div>
                                    <p>Dr. Chariar suggests Sanitation in India as an opportunity to unleash disruptive technology at UNDP’s Social Good Summit 2014.</p>
                                </Col>

                                <Col md="6" sm="12">
                                    <div className="video-container">
                                        <iframe className="yt-video" width="560" height="315" src="https://www.youtube.com/embed/3FHyCwiwYws?si=hAwWPIYN0ctj7oMt" frameBorder="0" allowFullScreen></iframe>
                                    </div>
                                    <p>Dr. Chariar speaks about his Fulbright experience with the United States India Educational Foundation (USIEF)</p>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </Container>

            <Container fluid>
                <Container className="section">
                    <Row>
                        <Col sm="12">
                            <h2 style={{ textAlign: "center" }}>Academic Contributions</h2>
                        </Col>
                        {Pub()}
                    </Row>
                    <Row className="justify-content-center">
                        <Col md="auto" sm="12"><Button href="./research/overview">All Work <i className="bi bi-arrow-right"></i></Button>
                        </Col>
                    </Row>
                </Container>
            </Container>
        </>
    )
}